import React from 'react';
import { Link } from 'react-router-dom';
import './ProductCard.css';

function ProductCard({ product, featured = false }) {
  return (
    <Link to={`/product/${product.id}`} className={`product-card ${featured ? 'product-card--featured' : ''}`}>
      {product.badge && (
        <div className="product-card__badge" style={{ background: product.color }}>
          {product.badge}
        </div>
      )}

      <div className="product-card__image-wrap">
        <img src={product.image} alt={product.name} className="product-card__image" />
      </div>

      <div className="product-card__content">
        <div className="product-card__header-row">
          <h3 className="product-card__name">{product.name}</h3>
          <div className="product-card__price-tag">
            <span className="product-card__price">₹{product.monthlyPrice.toLocaleString('en-IN')}</span>
            <span className="product-card__price-label">/month</span>
          </div>
        </div>

        <p className="product-card__tagline">{product.tagline}</p>

        <div className="product-card__plan-info">
          <span className="product-card__per-cup">₹{product.sellingPricePerCup}/cup</span>
          <span className="product-card__duration">{product.planDurationDays} Days</span>
        </div>

        <button
          className="btn btn-primary product-card__view-btn"
          style={{ background: `linear-gradient(135deg, ${product.color}, ${product.color}dd)` }}
        >
          View Details
        </button>
      </div>
    </Link>
  );
}

export default ProductCard;
